<template>


    <div class="p-3 pt-3 row">

        <div class="p-1 pt-1 col-3">
            <label class="control-sidebar-heading small">Select Application</label>
            <div>
                <select class="form-control form-control-sm" v-model="Application_data" name="Application" id="Application" @change="select_APP"
                        v-bind:disabled="running || scheduling">
                    <option v-for="(Application, index) in app" v-bind:value="Application">
                        {{ Application.description }}
                    </option>
                </select>
            </div>
        </div>

        <div class="p-1 pt-1 col-3">
            <label class="control-sidebar-heading small">Select Macro Load Area</label>
            <div>
                <select class="form-control form-control-sm" v-model="form.mla_identifier" @change="mla_selected">
                    <option v-for="la_identifier in form.mla_identifiers" :key="la_identifier" :value="la_identifier">
                        {{ la_identifier || 'Select Macro Load Area' }}  <!-- Show the placeholder if la_identifier is empty -->
                    </option>
                </select>
            </div>
        </div>


        <div class="p-1 pt-1 col-3">
            <label class="control-sidebar-heading small">Select Load Area</label>
            <div>
                <select class="form-control form-control-sm" v-model="LoadArea_data" name="LoadAreaID" id="LoadAreaID" @change="select_LA"
                        v-bind:disabled="running || scheduling">
                    <option v-for="(loadarea, index) in las" :key="index" v-bind:value="loadarea">
                        {{ loadarea.LoadAreaID || 'Select a Load Area' }}
                    </option>
                </select>
            </div>
        </div>

        <div class="p-1 pt-1 col-3">
            <label class="control-sidebar-heading small">Select MCU</label>
            <div>
                <select class="form-control form-control-sm" v-model="form.current_mcu" @change="mcu_selected">
                    <option v-for="current_mcu in form.mcu_identifiers" :key="current_mcu.mcu_id" :value="current_mcu.mcu_id">
                        {{ current_mcu.mcu_identifier|| 'Select MCU' }}  <!-- Show the placeholder if mcu_identifier is empty -->
                    </option>
                </select>
            </div>
        </div>

        <div class="p-1 pt-1 col-3">
            <label class="control-sidebar-heading small">Select Timeframe</label>
            <div>
                <select class="form-control form-control-sm" v-model="Timeframes_data" name="Timeframe" id="Timeframe" @change="select_Timeframe"
                        v-bind:disabled="running || scheduling">
                    <option v-for="(Timeframe, index) in timeframes" v-bind:value="Timeframe">
                        {{ Timeframe }}
                    </option>
                </select>
            </div>
        </div>

    </div>

</template>

<script>
import moment from 'moment'
export default {

    mounted() {
        //console.log('LoadAreaSelect ready.');
        this.getApplication();
        console.log('APP', this.Application)
        this.update_mlas();
        this.getLoadAreas();
        this.Timeframe = this.$store.state.timeframe;

        //EventBus.$on('applicationchanged', () => {
        //    this.getLoadAreas();
        //    });
    },
    data() {
        return {
            form: new Form({
                mla_identifier: '',
                la_identifier: '',
                current_mcu: '',
                current_mcu_identifier: '',
                mcu_identifiers: '',
            }),
            app: [],
            las: [],
            mcu: [],
            timeframes: [
                'Last 24 Hours', 'Last 7 Days', 'Last 14 Days', 'All'
            ],
            MaxPower: 300,
            MCU_data: {},
            LoadArea_data: {},
            Application_data: {},
            Timeframes_data: {}
        }
    },
    computed: {

        MCU_ID: {
            // getter
            get: function () {
                return this.$store.state.MCU.id
            },
            // setter
            set: function (newValue) {
                this.$store.state.MCU.id = newValue
            }
        },

        MCU_Identifier: {
            // getter
            get: function () {
                return this.$store.state.MCU.identifier
            },
            // setter
            set: function (newValue) {
                this.$store.state.MCU.identifier = newValue
            }
        },


        MacroLoadAreaID: {
            // getter
            get: function () {
                return this.$store.state.macroLoadArea.id
            },
            // setter
            set: function (newValue) {
                this.$store.state.macroLoadArea.id = newValue
            }
        },


        LoadAreaID: {
            // getter
            get: function () {
                return this.$store.state.loadArea.id
            },
            // setter
            set: function (newValue) {
                this.$store.state.loadArea.id = newValue
            }
        },
        LoadAreaID_class_name: {
            // getter
            get: function () {
                return this.$store.state.loadArea.class_name
            },
            // setter
            set: function (newValue) {
                this.$store.state.loadArea.class_name = newValue
            }
        },
        LoadAreaID_scenario: {
            // getter
            get: function () {
                return this.$store.state.loadArea.Scenario
            },
            // setter
            set: function (newValue) {
                this.$store.state.loadArea.Scenario = newValue
            }
        },

        Application: {
            // getter
            get: function () {
                return this.$store.state.application
            },
            // setter
            set: function (newValue) {
                this.$store.state.application = newValue
            }
        },

        Timeframe: {
            // getter
            get: function () {
                return this.$store.state.timeframe
            },
            // setter
            set: function (newValue) {
                this.$store.state.timeframe = newValue
            }            },

        running: function () {
            return this.$store.state.simulation.running;
        },
        scheduling: function () {
            return this.$store.state.simulation.scheduling;
        }
    },
    watch: {
        'Application': {
            handler (newData, oldData) {
                this.getLoadAreas();
            }
        },
        'form.mla_identifier': {
            handler(newMlaIdentifier) {
                if (newMlaIdentifier) {
                    // If a Macro Load Area is selected, filter the Load Areas
                    this.las = this.form.la_identifiers_by_mla_identifier[newMlaIdentifier];
                } else {
                    // If no Macro Load Area is selected, show all Load Areas
                    this.getLoadAreas();
                }
            },
            immediate: true // Trigger the watcher immediately when the component is mounted
        },
    },

    methods: {

        select_LA(){
            this.LoadAreaID = this.LoadArea_data.LoadAreaID;
            this.LoadAreaID_class_name = this.LoadArea_data.class_name;
            this.LoadAreaID_scenario = this.LoadArea_data.Scenario;
            this.loadMCU();
        },

        update_mlas() {
           // axios.get(`api/LA/getLoadAreaIdentifiersByMacroLoadAreaIdentifier`)
          axios.get('api/MLA/list')
                .then(response => {
                    if (response.status === 200 && response.data.success) {
                        this.form.mla_identifiers = [""];
                        this.form.la_identifiers_by_mla_identifier = {};

                        const mla_identifiers = response.data.data;

                        // for (const mla_identifier in mla_identifiers) {
                        //     this.form.mla_identifiers.push(mla_identifier);
                        //     const la_identifiers = mla_identifiers[mla_identifier];
                        //     la_identifiers.unshift(""); // Add default option for each MLA
                        //     this.form.la_identifiers_by_mla_identifier[mla_identifier] = la_identifiers;
                        // }
                      for (let i = 0; i < mla_identifiers.length; i++) {
                        let mla_identifier = mla_identifiers[i];
                        this.form.mla_identifiers.push(mla_identifier.MacroLoadAreaID);
                        let la_identifiers = mla_identifier; // If mla_identifiers contains LA identifiers
                        this.form.la_identifiers_by_mla_identifier[mla_identifier.MacroLoadAreaID] = la_identifiers;
                      }

                        // If no MLA is selected, fetch all Load Areas
                        this.getLoadAreas();
                    } else {
                        console.error(response.data);
                    }
                });
        },

        getLoadAreas() {
            // Pass the selected Macro Load Area ID to the backend
            const selectedMLA = this.form.mla_identifier || null;

            axios.get(`api/LA/ids/${this.$store.state.application}?macroLoadAreaID=${selectedMLA}`)
                .then(response => {
                    this.las = response.data;

                    // Add a default empty option
                    this.las.unshift({LoadAreaID: '', class_name: '', Scenario: ''});

                    // Initialize the dropdown
                    if (this.las.length > 0) {
                        this.LoadArea_data = this.form.la_identifier;
                        this.LoadAreaID = '';
                        this.LoadAreaID_class_name = '';
                        this.LoadAreaID_scenario = '';
                    }
                });
        },

        getApplication() {
            axios.get('api/getApplication')
                .then(response => {
                        this.app = response.data
                        if (this.app.length > 0) {
                            this.Application_data= this.app[0];
                            this.Application = this.app[0].description;
                        }
                    }

                )
        },

        select_APP() {
            this.Application = this.Application_data.description;
            console.log('APP', this.Application)
        },


        loadMCU(){
            axios.get('api/MCU/getMCUByLoadArea', {
                params: {
                    loadarea: this.LoadAreaID
                }
            }).then((response) => {
                this.form.mcu_identifiers = response.data;
            }).catch((error) => {
                console.error('Error fetching MCUs:', error);
            });
        },

        select_Timeframe() {
            this.Timeframe = this.Timeframes_data
            this.$store.state.timeframe = this.Timeframe
            console.log(this.$store.state.timeframe)

        },

        setMaxPower() {
            this.$http.post('P_MAX', { Power: this.MaxPower, LoadAreaID: this.LoadAreaID})
                .then(response => {
                    EventBus.$emit("timechanged");
                });
        },

        mla_selected(event) {
            this.form.mla_identifier = event.target.value; // Set selected MLA identifier in form
            this.MacroLoadAreaID = this.form.mla_identifier; // Stores MLA identifier
            this.getLoadAreas(); // Trigger loading of load areas based on selected MLA
        },


        mcu_selected(event) {
            // Ottieni l'ID del MCU selezionato
            const selectedMcuId = Number(event.target.value);
            //console.log('Selected MCUId:', selectedMcuId);

            // Trova l'oggetto MCU corrispondente all'ID selezionato
            const selectedMcu = this.form.mcu_identifiers.find(mcu => Number(mcu.mcu_id) === selectedMcuId);
            //console.log('Selected mcu_identifiers:', this.form.mcu_identifiers);
            //console.log('Selected MCU:', selectedMcu);


            if (selectedMcu) {
                // Ora puoi ottenere sia il mcu_identifier che l'mcu_id
                this.form.current_mcu_identifier = selectedMcu.mcu_identifier;  // Salva il mcu_identifier
                //console.log('Selected MCU Identifier:', this.form.current_mcu_identifier);  // Mostra il mcu_identifier selezionato

                // Aggiorna il valore dell'ID (già fatto dal v-model)
                this.MCU_ID = selectedMcuId; // Salva l'ID del MCU selezionato
                this.MCU_Identifier = this.form.current_mcu_identifier
            } else {
                //console.log('MCU not found for selected ID');
            }
        }
    }
}
</script>
